n<template>
<div style="padding-top: 35px">
    <div class="d-block row">
        <div class="col-lg-12">
            <div class="row" style="margin-top: -48px !important; margin-bottom: 10px !important">
                <b-tabs :class="{ 'offset-lg-3': ShowFilter }" class="inside-tab" v-model="OutsideIndex" @input="tabChange()">
                    <b-tab title="Requests"> </b-tab>
                </b-tabs>
            </div>
            <div class="row" :style="{
            'margin-bottom': index != 0 ? '10px' : 'auto',
          }">
                <button style="margin-left: 9px !important" class="btn btn-link text-uppercase Open-Filter" @click="openfilter()" v-show="!ShowFilter">
                    <b-img width="11" height="9" :src="openFilterIcon" /> Open Filter
                </button>
                <div class="offset-lg-3" v-show="ShowFilter">
                    <button style="margin-left: -12px !important" class="btn btn-link text-uppercase Close-Filter" @click="closefilter()">
                        <b-img width="11" height="9" :src="closeFilterIcon" /> Close
                        Filter
                    </button>
                </div>
            </div>

            <div class="row mb-3">
                <div v-bind:class="[
              {
                'col-md-6 ': !ShowFilter,
                'col-md-4 offset-md-3': ShowFilter,
              },
            ]">
                    <div class="row" v-if="OutsideIndex==0">
                        <div class="col-lg-4" :class="{ 'col-lg-5': ShowFilter }">
                            <OmniSelect v-model="InsideIndex" :options="FilterTabOptions" name="" :showLabel="false" placeholder="" :showSearch="false" />

                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" v-model="filter" placeholder="Search" />
                        </div>
                    </div>
                </div>
                <div v-bind:class="[
              {
                'col-md-6 text-right ': !ShowFilter,
                'col-md-5 text-right': ShowFilter,
              },
            ]">
                    <b-button class="btn custom-button" text="Download As Excel" @click="DownloadList()" variant="outline-primary">
                        Download As Excel
                    </b-button>
                    <button class="btn custom-button btn-primary" v-if="this.CanCreateReportingEntityRequest" @click="CreateRequest()" id="create-reporting-entity-request" text="Create Request">
                        CREATE REQUEST
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3" v-if="ShowFilter">
                    <div>
                        <div class="form-group col-md-12">
                            <OmniSelect class="omniipclass" :options="EntityList" v-model="FilterList.LegalEntity" name="Entity" placeholder="Filter by Entity" :showSearch="false" :showSelectAll="true" selectAllText="All" unSelectAllText="None" multiple="true"/>
                        </div>
                        <div class="form-group col-md-12">
                            <OmniSelect class="omniipclass" :options="AgencyList" v-model="FilterList.Agency" name="Agency" placeholder="Filter by Agency" :showSearch="false" :showSelectAll="true" selectAllText="All" unSelectAllText="None" multiple="true"/>
                        </div>
                        <div class="form-group col-md-12">
                            <OmniSelect class="omniipclass" :options="StatusOptions" v-model="FilterList.Status" name="STATUS" placeholder="Filter by Status" :showSearch="false" :showSelectAll="true" selectAllText="All" unSelectAllText="None" multiple="true"/>
                        </div>
                        <div class="row text-right">
                            <div class="col-md-11 p-0">
                                <button class="btn btn-primary text-uppercase" :disabled="!IsFormFilterValid" v-on:click="ResetValues()">
                                    RESET
                                </button>
                                <button class="btn btn-primary text-uppercase" :disabled="!IsFormFilterValid" v-on:click="FilterQuery()">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="[
              { 'col-md-12 ': !ShowFilter, 'col-md-9': ShowFilter },
            ]">
                    <b-table id="all-items" :per-page="perPage" :items="data.rows" :fields="fields" :no-local-sorting="true" @sort-changed="sortChange" show-empty striped hover responsive class="all-items">

                        <template v-slot:cell(CreatedDate)="data">
                            <div class="text-center">
                                {{ data.value | formatDate }}
                            </div>
                        </template>
                        <template v-slot:cell(Actions)="data">

                            <div class="action-cell" style="display:inline">
                                <b-img width="12" height="12" :src="auditIcon" @click="showAuditTrail(data.item.Id, data.item.RequestType)" class="audit-trail" title="Audit Trail" v-b-tooltip.hover.top />
                            </div>
                        </template>
                        <template v-slot:cell(SuggestedEntity)="data">

                            <a class="edit-link" @click="
                                navigateToEdit(
                                data.item.Id,
                                data.item.RequestType,
                                data.item.Status,
                                data.item.Requestor
                                )
                            ">{{data.item.SuggestedEntity}}</a>
                        </template>

                        <template v-slot:table-colgroup="scope" v-if="allRequest">
                           <col v-for="field in scope.fields"
                                :key="field.key"
                                :style="{
                                    width: field.label === 'Request' ? '300px' : field.key === 'audit' ? '50px' : 'auto',
                                }"/>
                        </template>
                        <template v-slot:cell(RequestType)="data">
                            <div class="text-center">
                                {{ data.value  }}
                            </div>
                        </template>
                        <template v-slot:cell(CompletionDate)="data">
                            <div class="text-center">
                                {{ data.value | formatDate }}
                            </div>
                        </template>

                        <template v-slot:cell(Requestor)="data">
                            <div>
                                {{ formatRequestor(data.value) }}
                            </div>
                        </template>
                        <template v-slot:cell(Status)="data">
                            <div style="white-space: nowrap" class="text-left">
                                <span :style="getBackgroundColor(data.value)">
                                    {{ formatStatus(data.value) }}
                                </span>
                            </div>
                        </template>
                        <template slot="custom-foot" v-if="IsPaginationRequired">
                            <b-tr>
                                <b-td class="custom-pagination" colspan="13">
                                    <b-form-select class="records-per-page" v-model="perPage" :options="RecordsPerPageOption"></b-form-select>
                                    <Pagination style="float: right" :per-page="perPage" aria-controls="open-items" v-model="currentPage" :total-rows="TotalRows" first-number last-number />
                                </b-td>
                            </b-tr>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
    <component :is="currentAuditTrail" v-bind="{ id: requestId, closeAuditModal: closeAuditModal }" @closeAudit="closeAudit()"></component>
</div>
</template>

<script>
const moment = require("moment");
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import {formatRequestor} from "../utilities/Helper";
import {mapGetters} from "vuex";
import {UpdateRecordsPerPageOption} from "../utilities/paginationUtils";
import service from "../services/Dropdowns";
import * as ReportingEntityWorkflowStates from "../utilities/ReportingEntityWorkflowStates";
export default {
    components: {
        DateRangePicker,
    },

    data() {
        return {
            AgencyName: null,
            EntityName: null,
            HFMEntity:null,
            EntityList: [],
            AgencyList: [],
            RecordsPerPageOption: [],
            deleteIcon: require("@/assets/Icons/delete.svg"),
            collapseIcon: require("@/assets/Icons/arrow-down.svg"),
            expandIcon: require("@/assets/Icons/rightarrow.svg"),
            editIcon: require("@/assets/Icons/edit.svg"),
            FilterTabOptions: [{
                    label: 'All Requests',
                    value: "0"
                },             
                {
                    label: 'Pending',
                    value: "1"
                },
                {
                    label: 'Completed',
                    value: "2"
                },
            ],
            StatusOptions: [],
            button: "button title",
            InsideIndex: "0",
            OutsideIndex: 0,
            TotalRows: 0,
            requestType: null,
            requestId: 0,
            closeAuditModal: true,
            closeFilterIcon: require("@/assets/Icons/close-filter-icon.svg"),
            openFilterIcon: require("@/assets/Icons/open-filter-icon.svg"),
            auditIcon: require("@/assets/Icons/auditTrail_icon.svg"),
            filter: null,
            sortBy: "CreatedDate",
            sortDesc: true,
            theme: "row",
            ShowFilter: false,
            FilterList: {
                Status: [],
                Agency: [],
                LegalEntity: [],
            },
            Status: [],
            showSelectAll: true,
            getFixed: true,
            perPage: 10,
            currentPage: 1,
            fields: this.buildColumns(),
            data: {
                config: {
                    card_mode: false,
                    show_refresh_button: false,
                    show_reset_button: false,
                    pagination_info: true,
                    global_search: {
                        visibility: false,
                    },
                },
                loading: false,
                classes: {
                    tableWrapper: "outer-table-div-class wrapper-class-two grid-table",
                    table: {
                        "table-sm": true,
                    },
                },
                rows: [],
            },
        };
    },
    created() {
        this.setStatusOptions();
        this.$store.commit("client/reset");
        this.$on("closeAudit", function () {
            this.closeAudit();
        });
        this.canCheckAccess();
    },
    props: {
        allRequest: {
            type: Boolean,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        requestid: {
            type: Number,
            required: false,
        },
    },
    mounted() {
        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);
        });
    },
    watch: {
        ShowFilter:function(value){
            if(value == true){
                this.LoadDropdownValues();
                this.LoadAgency();
            }
        },
        InsideIndex: function () {
            this.fields = this.buildColumns();
            this.GetRequests();
        },
        filter(e) {
            if ((e != null && e.length > 2) || e == null || e.length == 0) {
                this.GetRequests();
            }
        },
        currentPage: function (value) {
            if (value != null && parseInt(value) > 0) {
                this.GetRequests();
            }
        },
        perPage: function () {
            this.currentPage = 1;
            this.GetRequests();
        },
    },
    computed: {
        canApproveReportingEntityRequestLevel1() {
            return this.$store.getters.canApproveReportingEntityRequestLevel1;
        },
        canApproveReportingEntityRequestLevel2() {
            return this.$store.getters.canApproveReportingEntityRequestLevel2;
        },
        canCompleteReportingEntityRequest() {
            return this.$store.getters.canCompleteReportingEntityRequest;
        },
        CanCreateReportingEntityRequest() {
            return this.$store.getters.canCreateReportingEntityRequest;
        },
        IsFormFilterValid() {
            return this.FilterList.Status.length > 0 || this.FilterList.Agency.length > 0 || this.FilterList.LegalEntity.length > 0;
        },
        ...mapGetters({
            loggedInUser: "emailAddress"
        }),
        IsPaginationRequired() {
            return this.TotalRows != null && parseInt(this.TotalRows) > parseInt(this.perPage);
        },
        currentAuditTrail() {
            return this.closeAuditModal != true ?
                this.requestType === "Reporting Entity Request" ?
                "reporting-entity-audit" :
                "" : "";
        },
        CanAccessList() {
            return this.$store.getters.canAccessList || this.canCreateReportingEntityRequest;
        },
    },
    filters: {
        formatDate(date) {
            return moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : "-";
        },

    },
    methods: {
        navigateToEdit(id, requestType, status, email) {
            if (status == ReportingEntityWorkflowStates.FinanceDirectorApproval) {
                if (this.canApproveReportingEntityRequestLevel1) {
                    this.$router.push({
                        path: `ReportingEntity/ApprovalLevel/${id}`
                    });
                } else {
                    this.$store.dispatch(
                        "progress/setErrorMessage",
                        `Don't have permission to approve the request`
                    );
                }
            }  else if (status == ReportingEntityWorkflowStates.FinancialSystemsDirectorApproval) {
                if (this.canApproveReportingEntityRequestLevel2) {
                    this.$router.push({
                        path: `ReportingEntity/ApprovalLevel/${id}`
                    });
                } else {
                    this.$store.dispatch(
                        "progress/setErrorMessage",
                        `Don't have permission to approve the request`
                    );
                }
            }   else if (status == ReportingEntityWorkflowStates.PendingCompletionStates) {
                if (this.canCompleteReportingEntityRequest) {
                    this.$router.push({
                        path: `ReportingEntity/ApprovalLevel/${id}`
                    });
                } else {
                    this.$store.dispatch(
                        "progress/setErrorMessage",
                        `Don't have permission to Complete the request`
                    );
                }
            }
            else if (status == ReportingEntityWorkflowStates.Rejected) {
                if (this.isRequestorbyEmail(email) && this.CanCreateReportingEntityRequest) {
                    this.$router.push({
                        name: `Agency/HFM Info`,
                        params: {
                            id: parseInt(id)
                        },
                    })
                } else {
                    this.$store.dispatch(
                        "progress/setErrorMessage",
                        `Don't have permission to edit the request`
                    );
                }
            } else if (status == ReportingEntityWorkflowStates.Final) {
                this.$store.dispatch(
                    "progress/setErrorMessage",
                    `Request is completed or not started`
                );
            }
        },
        async setStatusOptions(){
            ReportingEntityWorkflowStates.AllStates.forEach(status => {
                this.StatusOptions.push({
                    label : status,
                    value : status
                })
            });
        },
        canCheckAccess() {
            if (this.CanAccessList) {
                this.GetRequests();
            } else {
                this.$router.push({
                    name: "unauthorized",
                    params: {
                        message: "UnAuthorized"
                    },
                });
            }
        },
        CreateRequest() {
            this.$router.push('/Request/ReportingEntity/AgencyInfo');
        },
        isRequestorbyEmail(email) {
            return email.toLowerCase() == this.loggedInUser.toString().toLowerCase();
        },
        tabChange() {
            this.fields = this.buildColumns();
            this.applyFilter();
        },
        applyFilter() {
            if (this.InsideIndex == 1) {
                this.FilterList.Status = [];
                this.FilterList.Status.push(ReportingEntityWorkflowStates.FinanceDirectorApproval);
                this.FilterList.Status.push(ReportingEntityWorkflowStates.FinancialSystemsDirectorApproval);
                this.FilterList.Status.push(ReportingEntityWorkflowStates.PendingCompletionStates);
            } else if (this.InsideIndex == 2) {
                this.FilterList.Status = [];
                this.FilterList.Status.push(ReportingEntityWorkflowStates.Final);
            } else {
                this.FilterList.Status = [];
            }
            this.currentPage = 1;
            this.GetRequests();
        },
        formatRequestor(email) {
          return formatRequestor(email)
        },
        formatStatus(status) {
            if (status != null && status != '') {
                if (status == "Final" || status == "Done" || status == "Completed") {
                    return "Completed";
                } else if (status == "Rejected") {
                    return "Rejected";
                } else {
                    return `Pending ${status}`;
                }
            } else {
                return '-';
            }
        },
        sortChange(e) {
            this.sortBy = e.sortBy;
            this.sortDesc = e.sortDesc;
            this.GetRequests();
        },
        GetGridOptions() {
            let extraFilters = [];
            if (this.FilterList.LegalEntity != null && this.FilterList.LegalEntity.length > 0) {
                extraFilters.push({
                    Field: "LegalEntity",
                    Operator: "=",
                    Value: this.FilterList.LegalEntity.join(","),
                });
            }
            if (this.FilterList.Agency != null && this.FilterList.Agency.length > 0) {
                extraFilters.push({
                    Field: "Agency",
                    Operator: "=",
                    Value: this.FilterList.Agency.join(","),
                });
            }
            if (this.FilterList.Status != null && this.FilterList.Status != "") {
                extraFilters.push({
                    Field: "Status",
                    Operator: "=",
                    Value: this.FilterList.Status.join(","),
                });
            }
            return {
                PageSize: parseInt(this.perPage),
                CurrentPageNumber: parseInt(this.currentPage),
                FilterValue: this.filter,
                SortBy: this.sortBy,
                SortDesc: this.sortDesc,
                Filters: extraFilters,
                Status: parseInt(this.InsideIndex),
                IsDraftType: this.OutsideIndex == 1
            };
        },
        buildColumns() {
            let columns = [];
            columns.push({
                key: "Actions",
                label: "Actions",
            })
            columns.push({
                key: "EntityName",
                label: "Entity",
                sortable: false,
            })
            columns.push({
                key: "AgencyName",
                label: "Agency",
                sortable: true
            })
             columns.push({
                key: "HFMEntity",
                label: "HFM Entity/Hyperion",
                sortable: true
            })
            columns.push({
                key: "SuggestedEntity",
                label: "Request",
                visible: false
            })
            columns.push({
                key: "Requestor",
                label: "Requestor",
                sortable: true,
                class: "NameHoverclass",
            })
            columns.push({
                key: "RequestType",
                label: "Request Type",
                sortable: false,
            })
            columns.push({
                key: "Status",
                label: "Status",
                sortable: true,
            })
            columns.push({
                key: "CreatedDate",
                label: "Requested Date",
                sortable: true,
            })
            columns.push({
                key: "CompletionDate",
                label: "Completed Date",
                sortable: true,
            });

            if (this.allRequest && this.InsideIndex != 3) {
                columns.push({
                    key: "CompletionDate",
                    label: "Date Completed",
                    sortable: true,
                    align: 'center'
                });
            }
            return columns;
        },
        DownloadList() {
            this.$store
                .dispatch("reportingEntity/DownloadList", this.GetGridOptions())
                .then((response) => {
                    const type = response.headers["content-type"];
                    const blob = new Blob([response.data], {
                        type: type,
                        encoding: "UTF-8",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Requests_${moment().format("MMDDYYYYmmhhss")}.xlsx`;
                    link.click();
                    link.remove();
                })
                .catch(() => {
                    this.$store.dispatch(
                        "progress/setErrorMessage",
                        `Error downloading requests.`
                    );
                });
        },
        closeAudit() {
            this.closeAuditModal = true;
        },
        showAuditTrail(id, requestType) {
            this.requestId = id;
            this.requestType = requestType;
            this.closeAuditModal = false;
        },
        GetRequests() {
            this.TotalRows = 0;
            this.data.rows = [];
            this.$store
                .dispatch("client/ReportingEntityRequests", this.GetGridOptions())
                .then((res) => {
                    if (res.data) {
                        this.TotalRows = res.data.Total;
                        this.data.rows = res.data.Result;
                        this.RecordsPerPageOption = UpdateRecordsPerPageOption(this.TotalRows);
                    }
                })
                .catch((ex) => {
                    if (ex.response) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error fetching requests.${ex}`
                        );
                    }
                });
        },
        FilterQuery: function () {
            this.currentPage = 1;
            this.GetRequests();
        },
        ResetValues: function () {
            this.FilterList.LegalEntity = [];
            this.FilterList.Agency = [];
            this.FilterList.Status = [];
            this.currentPage = 1;
            this.GetRequests();
        },
        closefilter() {
            this.theme = "row";
            this.ShowFilter = false;
        },
        openfilter() {
            (this.theme = "col-md-9"), (this.ShowFilter = true);
        },
        getWindowWidth: function () {
            this.getFixed = document.documentElement.clientWidth > 992 ? true : null;
        },
        getBackgroundColor: function (status) {
            let color = "#8c8c8c";
            let emptyStatus = '';
            let emptyStatusNull = null;
            switch (status) {
                case ReportingEntityWorkflowStates.FinanceDirectorApproval:
                    color = "#efa56a";
                    break;
                case ReportingEntityWorkflowStates.FinancialSystemsDirectorApproval:
                    color = "#efa56a";
                    break;
                case ReportingEntityWorkflowStates.PendingCompletionStates:
                    color = "#efa56a";
                    break;
                case ReportingEntityWorkflowStates.Final:
                    color = "#2cc4ad";
                    break;
                case ReportingEntityWorkflowStates.Rejected:
                    color = "#df5678";
                    break;
                case emptyStatus:
                    color = "";
                    break;
                case emptyStatusNull:
                    color = "";
                    break;
                default:
                    color = "#ccc";
                    break;
            }
            return {
                color: color,
                "font-weight": 600
            };
        },
        LoadDropdownValues() {
            service.getOriginalEntityRecords("Financial Entity")
                .then((res) => {
                    this.EntityList = res.data;
                })
                .catch((err) => {
                    alert(err);
                });
        },
        LoadAgency() {
            service
                .getAgencyDropdownValues("")
                .then((res) => {
                    this.AgencyList = res.data;
                })
                .catch((err) => {
                    alert(err);
                });
        },
    },
};
</script>
